import type { PeoCompanyType, SignUpMethod } from 'src/api';

export const PeoSettingsFormFields = {
  companyType: 'companyType',
  pinHint: 'pinHint',
  signUpMethod: 'signUpMethod',
} as const;

export type PeoSettingsFormValues = {
  [PeoSettingsFormFields.companyType]: PeoCompanyType;
  [PeoSettingsFormFields.signUpMethod]: SignUpMethod;
  [PeoSettingsFormFields.pinHint]?: string | null;
};
